import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import AddParticipantStore from '../../../../../Store';
import { SelectParticipantsState } from '../../../../../Types';
import Participants from './Participants';
import NoParticipants from '../../../../../../../DeepLinks/DeepLinksBody/InviteParticipantModal/RenderInviteParticipantsModal/ReadyModal/Body/ParticipantsList/NoParticipants';

export interface Props {
  store: AddParticipantStore;
  state: SelectParticipantsState;
}

const ParticipantsList: React.FC<Props> = ({ store, state }) =>
  fromEmpty([...state.newGroupsAndParticipants])
    .map(() => (
      <Participants
        store={store}
        activationsRemaining={state.activationsRemaining}
        title={state.publicName}
        newLicenseAllocations={state.newLicenseAllocations}
        allocatedLicenses={state.allocatedLicenses}
        newGroupsAndParticipants={state.newGroupsAndParticipants}
      />
    ))
    .getOrElse(() => <NoParticipants submit={store.submit} />);

export default observer(ParticipantsList);
